import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SearchSelectForm from '../Forms/SearchSelectForm'
import { getFormOptions } from '../../actions/form.actions'

const FilterDialog = ({
  context = 'filter', // filter | save
  showDialog = false, 
  onUpdate = () => {}, 
  onCancel = () => {} 
}) => {
  const dispatch = useDispatch()

  const ingredientOptions = useSelector(state => state.form_options?.ingredient_options || [])
  const categoryOptions = useSelector(state => state.form_options?.category_options || [])

  const [saveFilters, setSaveFilters] = useState(false)
  const [isOpen, setIsOpen] = useState(true)
  const [includeExclude, setIncludeExclude] = useState('include')
  const [selectedFilters, setSelectedFilters] = useState([])

  const [currentTab, setCurrentTab] = useState('preferences')
  const appliedFiltersContainerRef = useRef(null)
  
  /**
   * Hooks
   */
  useEffect(() => {
    dispatch(getFormOptions())

    const filters = localStorage.getItem('filters') ?? '[]'
    
    if(filters && JSON.parse(filters)?.length > 0) {
      setSelectedFilters(JSON.parse(filters))
      setSaveFilters(true)
    }
  }, [])

  useEffect(() => { 
    setIsOpen(showDialog) 
  }, [showDialog])

  const isSelectedPreference = (val) => {
    const index = selectedFilters?.findIndex(f => f?.value === val)
    return (index > -1)
  }
  /**
   * Handlers
   */
  const handleSelectPreference = (e) => {
    const selectFiltersCopy = [...selectedFilters]

    if (e?.target?.checked) {
      selectFiltersCopy?.push({
        value: e?.target?.value,
        name: e?.target.value,
        type: 'preference'
      })
    } else {
      const index = selectFiltersCopy?.findIndex(f => f?.value === e?.target?.value)
      selectFiltersCopy?.splice(index, 1)
    }

    setSelectedFilters(selectFiltersCopy)

    if (appliedFiltersContainerRef.current) {
      setTimeout(() => {
        appliedFiltersContainerRef.current.scrollTop = appliedFiltersContainerRef.current.scrollHeight;
      }, 10)
    }
  }

  const handleRemoveFilter = (index) => {
    const selectFiltersCopy = [...selectedFilters]
    selectFiltersCopy.splice(index, 1)
    setSelectedFilters(selectFiltersCopy)

    if (appliedFiltersContainerRef.current) {
      setTimeout(() => {
        appliedFiltersContainerRef.current.scrollTop = appliedFiltersContainerRef.current.scrollHeight;
      }, 10)
    }
  }
  
  const handleSelectIngredient = (index, option) => {
    if (!selectedFilters.includes(option)) {
      const selectFiltersCopy = [...selectedFilters]
      
      option['type'] = 'ingredient'
      option['includeExclude'] = includeExclude

      selectFiltersCopy.push(option)
      setSelectedFilters(selectFiltersCopy)

      if (appliedFiltersContainerRef.current) {
        setTimeout(() => {
          appliedFiltersContainerRef.current.scrollTop = appliedFiltersContainerRef.current.scrollHeight;
        }, 10)
      }
    }
  }

  const handleSelectCategory = (index, option) => {
    if (!selectedFilters.includes(option)) {
      const selectFiltersCopy = [...selectedFilters]

      option['type'] = 'category'
      option['includeExclude'] = includeExclude

      selectFiltersCopy.push(option)
      setSelectedFilters(selectFiltersCopy)

      if (appliedFiltersContainerRef.current) {
        setTimeout(() => {
          appliedFiltersContainerRef.current.scrollTop = appliedFiltersContainerRef.current.scrollHeight;
        }, 10)
      }
    }
  }

  const handleCancel = () => {
    localStorage.setItem('filters', '[]')
    setSelectedFilters([])
    setIsOpen(false)
    onCancel()
  }

  const handleConfirm = () => {
    if(saveFilters) {
      localStorage.setItem('filters', JSON.stringify(selectedFilters))
    }
    onUpdate(selectedFilters)
    setIsOpen(false)
  }

  return (
    <div
      className={`fixed z-50 inset-0 overflow-y-auto ${
        isOpen ? 'flex' : 'hidden'
      } items-center justify-center`}
    >
      <div className="fixed inset-0 bg-an_green-dark opacity-60"></div>

      <div className="fixed bottom-0 w-screen z-50"> 
        <div className="flex flex-wrap justify-end items-end z-50 max-h-[100px] lg:h-[200px] overflow-y-auto md:max-w-xl mx-auto" ref={appliedFiltersContainerRef}>
            {
              selectedFilters && 
                selectedFilters.map((i, index) => {
                  return (
                    <div 
                      key={index} 
                      className={`m-1 p-1 h-6 text-xs rounded text-an_white ${i?.includeExclude === 'exclude' ? 'bg-an_orange' : 'bg-an_green-light'}`}>
                        <span>{i.name}</span>
                        <span className="ml-2" onClick={() => { handleRemoveFilter(index) }}>&times;</span>  
                    </div>
                  )
                })
            }
        </div>

        <div className="px-2">
          <div className="bg-an_white-dark rounded-md shadow-md md:max-w-xl mx-auto">
            <div className="w-full flex justify-between items-center p-2 bg-an_green-dark rounded-t" >
              
              <div className="">
                <div className="text-xl font-semibold text-an_white pb-2">{ context === 'filter' ? 'apply filters' : 'set preferences' }</div>
            
                <div className="flex items-center">
                    <input 
                        onChange={(e) => { setSaveFilters(!saveFilters) }}
                        checked={saveFilters} 
                        id="Save" 
                        type="checkbox" 
                        value="Save" 
                        className="w-4 h-4 text-an_white bg-an_white border-an_green-dark rounded" 
                    />
                    <label 
                        htmlFor="Save" 
                        className="ml-2 text-xs font-medium text-an_white"
                    >Save</label>
                </div>
              </div>

              <div className="relative">
                <div className="w-full flex justify-end">
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input 
                      type="checkbox" 
                      value="includeExclude"
                      onChange={() => {
                        const copy = includeExclude === 'include' ? 'exclude' : 'include'
                        setIncludeExclude(copy)
                      }}
                      checked={(includeExclude === 'include')} 
                      className="sr-only peer" 
                      />
                    <div 
                      
                      className={`
                          w-9 h-5 bg-an_orange
                          rounded-full peer
                          peer-checked:after:translate-x-full peer-checked:after:border-an_white after:content-[''] 
                          after:absolute after:top-[2px] after:left-[2px] 
                          after:bg-an_white
                            after:rounded-full after:h-4 after:w-4 after:transition-all 
                        peer-checked:bg-an_green-light

                      `}></div>
                    <span className="ml-3 text-xs font-medium text-an_white">{includeExclude}</span>
                  </label>
                </div>
              </div>
            </div>

            <div className="flex min-w-full justify-center"> 
                <div className="w-full bg-an_white-dark pt-2">

                    <ul className="flex text-sm font-medium text-center border-b-2 border-an_orange-dark overflow-hidden px-2">
                        <li className="w-full">
                            <a href="#" 
                              onClick={() => { setCurrentTab('ingredients') }}
                              className={`${currentTab === 'ingredients' ? 'text-an_white bg-an_orange-dark active' : 'text-an_orange-dark '} inline-block w-full p-2 rounded-t-lg`}>ingredients</a>
                        </li>
                        <li className="w-full">
                            <a href="#" 
                              onClick={() => { setCurrentTab('categories') }}
                              className={`${currentTab === 'categories' ? 'text-an_white bg-an_orange-dark active' : 'text-an_orange-dark '} inline-block w-full p-2 rounded-t-lg`}>categories</a>
                        </li>
                        <li className="w-full">
                            <a href="#"
                              onClick={() => { setCurrentTab('preferences') }}
                              className={`${currentTab === 'preferences' ? 'text-an_white bg-an_orange-dark active' : 'text-an_orange-dark '} inline-block w-full p-2 rounded-t-lg`}>preferences</a>
                        </li>
                    </ul>
            
                </div>
            </div>

            { 
              currentTab === 'ingredients' &&
                <div>
                  <SearchSelectForm 
                      label="Filter Ingredients"
                      limit={3}
                      options={ingredientOptions} 
                      selectedOptions={selectedFilters}
                      onSelectItem={(newValue, option) => { handleSelectIngredient(newValue, option) }}
                      handleOnSelectSearchFocus={(newValue) => { }}
                      showOptions={currentTab === 'ingredients'}
                  />
                </div>
            }

            { 
              currentTab === 'categories' &&
                <div>
                  <SearchSelectForm 
                      label="Filter Categories"
                      limit={3}
                      options={categoryOptions} 
                      selectedOptions={selectedFilters}
                      onSelectItem={(newValue, option) => { handleSelectCategory(newValue, option) }}
                      handleOnSelectSearchFocus={(newValue) => { }}
                      showOptions={currentTab === 'categories'}
                  />
                </div> 
            }
          
            { 
              currentTab === 'preferences' && 
                <div className="h-[439px]">
                  <div className="mb-6 pt-6 px-2">
                    <div className="flex py-2 w-[150px] mx-auto items-center">
                      <input 
                          onChange={(e) => { handleSelectPreference(e) }}
                          checked={isSelectedPreference('vegan')} 
                          id="Vegan" 
                          type="checkbox" 
                          value="vegan" 
                          className="w-6 h-6 mt-1 text-an_green-dark bg-an_white border-an_green-dark rounded" 
                      />
                      <label 
                          htmlFor="Vegan" 
                          className="ml-2 text-lg font-medium text-an_green-dark"
                      >vegan</label>
                    </div>

                    <div className="flex py-2 items-center w-[150px] mx-auto">
                        <input 
                            onChange={(e) => { handleSelectPreference(e) }}
                            checked={isSelectedPreference('vegetarian')} 
                            id="Vegetarian" 
                            type="checkbox" 
                            value="vegetarian" 
                            className="w-6 h-6 mt-1 text-an_green-dark bg-an_white border-an_green-dark rounded" 
                        />
                        <label 
                            htmlFor="Vegetarian" 
                            className="ml-2 text-lg font-medium text-an_green-dark"
                        >vegetarian</label>
                    </div>

                    <div className="flex py-2 w-[150px] mx-auto items-center">
                        <input 
                            onChange={(e) => { handleSelectPreference(e) }}
                            checked={isSelectedPreference('gluten_free')}  
                            id="GlutenFree" 
                            type="checkbox" 
                            value="gluten_free" 
                            className="w-6 h-6 mt-1 text-an_green-dark bg-an_white border-an_green-dark rounded" 
                        />
                        <label 
                            htmlFor="GlutenFree" 
                            className="ml-2 text-lg font-medium text-an_green-dark"
                        >gluten free</label>
                    </div>

                    <div className="flex py-2 w-[150px] mx-auto items-center">
                        <input 
                            onChange={(e) => { handleSelectPreference(e) }}
                            checked={isSelectedPreference('sugar_free')}
                            id="SugarFree" 
                            type="checkbox" 
                            value="sugar_free" 
                            className="w-6 h-6 mt-1 text-an_green-dark bg-an_white border-an_green-dark rounded" 
                        />
                        <label 
                            htmlFor="SugarFree" 
                            className="ml-2 text-lg font-medium text-an_green-dark"
                        >sugar free</label>
                    </div>

                    <div className="flex py-2 w-[150px] mx-auto items-center">
                        <input 
                            onChange={(e) => { handleSelectPreference(e) }}
                            checked={isSelectedPreference('dairy_free')}
                            id="DairyFree" 
                            type="checkbox" 
                            value="dairy_free" 
                            className="w-6 h-6 mt-1 text-an_green-dark bg-an_white border-an_green-dark rounded" 
                        />
                        <label 
                            htmlFor="DairyFree" 
                            className="ml-2 text-lg font-medium text-an_green-dark"
                        >dairy free</label>
                    </div>
                  </div>
                </div>
            }
          </div>
        </div>

        <div className="flex justify-center w-full py-3 md:max-w-xl mx-auto">
            <button
              className="px-5 py-2 rounded w-36 text-an_green-dark bg-an_white mr-1"
              onClick={handleCancel}
            >
              cancel
            </button>

            <button
              className={`px-5 ml-1 py-2 relative rounded w-36 border border-an_orange-darker3 text-an_white bg-an_orange text-border-orange`}
              onClick={handleConfirm}
            >
              apply
            </button>
        </div>
      </div>

    </div>
  )
}

export default FilterDialog
